import {
  ChangeDetectionStrategy,
  Component,
  input,
  InputSignal,
  OnDestroy,
  OnInit,
} from '@angular/core';
import { FormGroup } from '@angular/forms';
import { ModelForm, SelectData, UserForm } from '../../models';
import { CPF_MASK } from '../../constants/cpf-validator.constants';
import { debounceTime, first, map, Observable, Subject, takeUntil } from 'rxjs';
import { UserService } from '../../services/user/user.service';

@Component({
  selector: 'app-register-fields',
  templateUrl: './register-fields.component.html',
  styleUrls: ['./register-fields.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RegisterFieldsComponent implements OnInit, OnDestroy {
  readonly cpfMask = CPF_MASK;

  groupsList$: Observable<SelectData[]> = this.userService.getGroupList().pipe(
    first(),
    map((data) =>
      data.data.map((data) => ({
        value: data,
        label: data.nome,
      }))
    )
  );

  formControlRef: InputSignal<FormGroup<ModelForm<UserForm>>> =
    input<FormGroup<ModelForm<UserForm>>>();

  showMessageError: boolean;

  private destroySubject: Subject<boolean> = new Subject();

  get userId(): number {
    return this.formControlRef()?.controls.id.value;
  }

  constructor(private userService: UserService) {}

  ngOnDestroy(): void {
    this.destroySubject.next(true);
    this.destroySubject.complete();
  }

  ngOnInit(): void {
    this.formControlRef()
      .valueChanges.pipe(debounceTime(100), takeUntil(this.destroySubject))
      .subscribe((formValue: UserForm) => {
        const repeatPassword = this.formControlRef().controls.repeatPassword;
        if (
          repeatPassword.dirty &&
          formValue.senha !== formValue.repeatPassword
        ) {
          this.showMessageError = true;
          this.formControlRef().controls.repeatPassword.setErrors({
            invalid: true,
          });
        } else {
          this.showMessageError = false;
        }
      });
  }
}
